
import Vue, { PropType } from "vue";
import { get_color_by_name } from "@/utils/colors";
import moment from "moment";
import { DateFilterPayload } from "@/store/modules/recruiter/interfaces";

export default Vue.extend({
  name: "EnglishSelectedDatePicker",
  data() {
    return {
      localDateFilter: [] as string[],
      menuOpen: false
    };
  },
  props: {
    selected_dates: {
      type: Object as PropType<DateFilterPayload>
    },
    /** When true, selecting one date filters for that day only (single-date mode for Summary Report). */
    singleDateOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "selected_dates.date_filter": {
      handler(newVal) {
        this.localDateFilter = newVal || [];
      },
      immediate: true
    },
    "selected_dates.date_picker_menu": {
      handler(newVal) {
        this.menuOpen = newVal || false;
      },
      immediate: true
    }
  },
  methods: {
    clear_dates() {
      this.localDateFilter = [];
      this.$emit("selected_dates", {
        date_filter: [],
        date_range_value: "",
        date_picker_menu: false
      });
    },
    transform_calender_icon(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("stroke", get_color_by_name("primary"));
      return icon;
    },
    async format_date_range(dates: string[]) {
      if (dates.length === 0) return;
      if (this.singleDateOnly && dates.length === 1) {
        // Single-date mode (e.g. Summary Report): use that day only
        const d = dates[0];
        this.menuOpen = false;
        this.$emit("selected_dates", {
          date_filter: [d, d],
          date_range_value: moment(d).format("DD MMM YYYY"),
          date_picker_menu: false
        });
        return;
      }
      if (dates.length === 1) {
        // Range mode: wait for second date
        return;
      }
      if (dates.length === 2) {
        const sortedDates = [...dates].sort();
        const dateRangeValue =
          moment(sortedDates[0]).format("DD MMM YYYY") +
          "  to  " +
          moment(sortedDates[1]).format("DD MMM YYYY");
        this.menuOpen = false;
        this.$emit("selected_dates", {
          date_filter: sortedDates,
          date_range_value: dateRangeValue,
          date_picker_menu: false
        });
      }
    }
  }
});
